export default __webpack_public_path__ + "assets/images/c48a652e5ac6b01806cc9ae5542ca291.svg";